// src/components/layout/Footer.jsx
import React, { useState } from "react";
import Arrow from "../../assets/img/Ico/Arrow.svg";
import lock from "../../assets/img/Ico/Lock.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const links = [
    { name: "Maison Sambin", url: "https://maisonsambin.com/" },
    { name: "Los Pistoleros", url: "https://los-pistoleros.com/" },
    { name: "People Restaurant", url: "https://www.people.restaurant/" },
    { name: "JPP Compta", url: "https://jppcompta.fr/" },
    { name: "Effet Mer", url: "https://effetmerplage.fr/" },
    { name: "Philippe Gauberti", url: "https://fannyart.fr/" },
    { name: "Smooss'", url: "https://www.smooss.fr/" },
    { name: "Orbisur", url: "https://orbisur.com/" },
    { name: "Villa Bono", url: "https://villa-bono.fr/" },
    { name: "Monkeys", url: "https://welcometothemonkeys.com/" },
    { name: "L'Antre", url: "https://lantre.club/" },
    { name: "Groupe Expression", url: "https://www.groupexpression.fr/" },
    { name: "GMC Custom", url: "https://gmc-custom.com/" },
    { name: "Brasserie L'Edhec", url: "https://edhec.le-393.com/" },
    { name: "Beezleads", url: "https://beezleads.com/" },
    { name: "Operandi Groupe", url: "https://operandi-groupe.com/" },
    { name: "JR Consulting", url: "https://jrconsult.fr/" },
    { name: "Azurea", url: "https://azureaprintsolutions.com/" },
    { name: "Dreamteam des Étudiants", url: "https://www.d-team.fr/" },
    { name: "Lexicredis", url: "https://lexicredis.fr/" },
    { name: "BPM Event", url: "https://www.bpm-events.fr/" },
    { name: "Nice Plomberie", url: "https://nice-plomberie.com/" },
    { name: "Viaveho", url: "https://viaveho.com/" },
    { name: "Up4Mind", url: "https://up4mind.com/" },
  ];

  return (
    <footer className="footer">
      <div className="footer-head">
        <button
          type="button"
          className={`footer-toggle ${open ? "open" : ""}`}
          aria-expanded={open}
          aria-controls="footer-client-links"
          onClick={() => setOpen((v) => !v)}
        >
          <span>{t("footer.toggle")}</span>
          <img
            src={Arrow}
            className="chevron arrow"
            alt={t("footer.altToggle")}
          />
        </button>
      </div>

      <div
        id="footer-client-links"
        className={`footer-collapse ${open ? "open" : ""}`}
      >
        <div className="footer-links">
          {links.map((link, i) => (
            <a
              key={i}
              href={link.url}
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>

      <div className="footer-credit">
        <span>
          {t("footer.creditPrefix", { year: new Date().getFullYear() })}
          <Link to="/mentions-legales" className="footer-legal-link">
            {t("footer.legal")}
          </Link>
        </span>
        <div className="footer-socials">
          <a href="https://www.instagram.com/maelcorporation/" target="_blank">
            [IG]
          </a>
          <a href="https://fr.linkedin.com/company/maelcorp" target="_blank">
            [LI]
          </a>
          <Link to="/password-generator">
            <img src={lock} alt={t("footer.altLock")} />
          </Link>
        </div>
      </div>
    </footer>
  );
}
